'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Plus = function Plus(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 445 445' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { fill: 'currentColor', d: 'M427.4 199.7H245.3V17.6h-45.6v182.1H17.6v45.6h182.1v182.1h45.6V245.3h182.1z', fillRule: 'evenodd', clipRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Plus;
//# sourceMappingURL=Plus.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Plus.js